import { NgClass } from "@angular/common";
import { Component, Input, inject, ChangeDetectionStrategy } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { CardComponent } from "@components/cards/card/card.component";
import { InputComponent } from "@components/input/input.component";
import { IArbetsorderDetail } from "~app/features/planera/model/IArbetsorderDetail";
import { IAtgard } from "~app/features/planera/model/IAtgard";
import { ArbetsorderAtgardService } from "../../arbetsorder-atgard.service";

@Component({
    selector: "rask-arbetsorder-atgard-produktion-avslutad-lev",
    templateUrl: "./arbetsorder-atgard-produktion-avslutad-lev.component.html",
    styleUrls: ["./arbetsorder-atgard-produktion-avslutad-lev.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        FormsModule,
        CardComponent,
        NgClass,
        InputComponent
    ]
})
export class ArbetsorderAtgardProduktionAvslutadLevComponent {
    readonly atgardService = inject(ArbetsorderAtgardService);

    @Input() atgard: IAtgard;
    @Input() arbetsorder: IArbetsorderDetail;
}
